import React from 'react';
import { COST_CENTER_TYPE_COLORS, STATUS } from '../../../core/constants/financial';

const CostCenterSummary = ({ costCenters }) => {
  const active = costCenters.filter((c) => c.status === STATUS.ATIVO);
  const produtivos = costCenters.filter((c) => c.type === 'produtivo' && c.status === STATUS.ATIVO);
  const administrativos = costCenters.filter((c) => (c.type === 'administrativo' || c.type === 'financeiro') && c.status === STATUS.ATIVO);

  return (
    <div className="fd-modal-summary">
      <div className="fd-modal-summary-item">
        <span className="fd-modal-summary-label">Total</span>
        <span className="fd-modal-summary-value">{costCenters.length}</span>
      </div>
      <div className="fd-modal-summary-item">
        <span className="fd-modal-summary-label" style={{ color: '#70E000' }}>Ativos</span>
        <span className="fd-modal-summary-value" style={{ color: '#70E000' }}>{active.length}</span>
      </div>
      <div className="fd-modal-summary-item">
        <span className="fd-modal-summary-label" style={{ color: COST_CENTER_TYPE_COLORS.produtivo.color }}>Produtivos</span>
        <span className="fd-modal-summary-value" style={{ color: COST_CENTER_TYPE_COLORS.produtivo.color }}>{produtivos.length}</span>
      </div>
      <div className="fd-modal-summary-item fd-modal-summary-item--last">
        <span className="fd-modal-summary-label" style={{ color: COST_CENTER_TYPE_COLORS.administrativo.color }}>Administrativos</span>
        <span className="fd-modal-summary-value" style={{ color: COST_CENTER_TYPE_COLORS.administrativo.color }}>{administrativos.length}</span>
      </div>
    </div>
  );
};

export default CostCenterSummary;
